module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/maro-4629206d5b7fe64dc5650734d7ec37a8.svg";